import React from 'react';
import TimeManager from './components/TimeManager/TimeManager';

const App = () => {
  return (
      <TimeManager />
  );
}

export default App;
